import { Link } from "react-router-dom";
import ContactForm from "@/pages/about/components/ContactForm";
import { useSeo } from "@/hooks/useSeo";

const values = [
  {
    icon: "ri-movie-2-line",
    title: "内容为本",
    desc: "持续收录电影、电视剧、综艺、动漫等优质影视资源，丰富你的观影选择。",
  },
  {
    icon: "ri-search-eye-line",
    title: "便捷体验",
    desc: "通过关键词搜索与多维筛选，帮助你在海量内容中快速定位想看的那一部。",
  },
  {
    icon: "ri-heart-3-line",
    title: "贴心收藏",
    desc: "一键收藏喜欢的影视，本地保存，随时回访，不怕找不到。",
  },
];

export default function About() {
  useSeo({
    title: "关于我们 - 91免费看片",
    description:
      "了解91免费看片：我们是一家高清影视在线观看平台，围绕电影、电视剧、综艺、动漫提供便捷查找与浏览体验，并提供意见反馈与联系渠道。",
    keywords: "关于我们,91免费看片,影视平台介绍",
  });

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      {/* Intro */}
      <div className="rounded-xl bg-primary-600 px-6 py-10 md:px-10 md:py-12">
        <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
          <i className="ri-information-line" /> 关于我们
        </span>
        <h2 className="mt-4 font-heading text-2xl font-extrabold text-background-50 md:text-3xl">
          91免费看片 · 高清影视在线观看平台
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-background-100/85">
          91免费看片致力于为广大影视爱好者提供便捷、清晰、易用的影视浏览体验。我们围绕电影、电视剧、综艺、动漫等丰富内容，提供关键词搜索、多维筛选、智能推荐与本地收藏等功能，让你更高效地发现并管理想看的内容。
        </p>
      </div>

      {/* Values */}
      <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
        {values.map((v) => (
          <div
            key={v.title}
            className="rounded-xl border border-background-200 bg-background-50 p-6"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
              <i className={`${v.icon} text-xl`} />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
              {v.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-500">{v.desc}</p>
          </div>
        ))}
      </div>

      {/* Content scope + disclaimer */}
      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <section className="rounded-xl border border-background-200 bg-background-50 p-6">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-list-check-2 text-primary-600" /> 内容范围说明
          </h3>
          <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-accent-500" />
              覆盖电影、电视剧、综艺、动漫四大频道，涵盖多种题材与地区。
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-accent-500" />
              支持按类型、地区、年份与题材筛选，并可按最新、热门、评分排序。
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-accent-500" />
              提供影视专题合集与相似内容推荐，帮助你发现更多好片。
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-circle-line mt-0.5 text-accent-500" />
              所有影视名称、海报与资料均为演示用虚构示例数据。
            </li>
          </ul>
        </section>

        <section className="rounded-xl border border-background-200 bg-background-50 p-6">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-shield-check-line text-primary-600" /> 用户声明与免责声明
          </h3>
          <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
            <p>
              本站为前端技术演示站点，不存储、不提供任何真实的影视文件或在线播放服务，页面中的播放按钮仅为交互演示。
            </p>
            <p>
              站内所展示的影视名称、海报与简介均为虚构示例，仅用于界面设计与功能展示，无意侵犯任何第三方的合法权益。
            </p>
            <p>
              若相关权利人认为部分内容涉及版权问题，请通过下方反馈渠道与我们联系，我们将在核实后及时处理。
            </p>
          </div>
          <div className="mt-5 flex flex-wrap gap-3">
            <span className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-600">
              <i className="ri-mail-line text-accent-500" /> feedback@91kanpian.example
            </span>
            <Link
              to="/special"
              className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-600 transition-colors hover:text-primary-700"
            >
              <i className="ri-bookmark-3-line text-accent-500" /> 浏览影视专题
            </Link>
          </div>
        </section>
      </div>

      {/* Contact form */}
      <div className="mt-10">
        <ContactForm />
      </div>
    </div>
  );
}